import isNil from 'lodash/isNil'

export const createPlaceholderForElement = (element: Element) => {
  const styles = window.getComputedStyle(element)

  const placeholder = document.createElement('div')
  Object.entries(styles).forEach(([key, value]) => {
    if (isNil(value)) return
    if (key === 'display') {
      /**
       * using "display: inline" will cause the placeholder to not take up any space.
       * So, we need to change it to "inline-block" to make the placeholder take up space.
       */
      placeholder.style.setProperty(key, value === 'inline' ? 'inline-block' : value)
      return
    }
    placeholder.style.setProperty(key, value)
  })

  return placeholder
}
